import React, {useEffect, useState} from "react";
import GoogleMapReact from 'google-map-react';
import axiosInstance from "../../AxiosInstance";

function PinMarker() {
    return (
        <div style={{
            width: '14px', height: '14px', borderRadius: '50%',
            backgroundColor: '#EF4444', border: '2px solid white',
            boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
            transform: 'translate(-50%, -50%)',
        }}/>
    );
}

export default function LocationWidget({deviceId, mqttData}) {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (!deviceId) return;
        axiosInstance.get(`device/${deviceId}/gps_position/`).then(res => {
            if (res.data.latitude && res.data.longitude) {
                setPosition({lat: res.data.latitude, lng: res.data.longitude, last_message: res.data.last_message});
            }
        }).catch(() => {});
    }, [deviceId]);

    // Update from MQTT data if available
    useEffect(() => {
        if (!mqttData || !Array.isArray(mqttData)) return;
        const latVar = mqttData.find(v => v.variable?.name?.toLowerCase().includes('lat'));
        const lngVar = mqttData.find(v => v.variable?.name?.toLowerCase().includes('lng') || v.variable?.name?.toLowerCase().includes('lon'));
        if (latVar && lngVar) {
            const lat = parseFloat(latVar.value);
            const lng = parseFloat(lngVar.value);
            if (!isNaN(lat) && !isNaN(lng)) {
                setPosition(prev => ({...prev, lat, lng}));
            }
        }
    }, [mqttData]);

    if (!position) {
        return (
            <div style={{
                height: '150px', borderRadius: '8px', backgroundColor: '#F1F5F9',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#94A3B8', fontSize: '13px', border: '1px solid #E2E8F0',
            }}>
                No GPS data
            </div>
        );
    }

    return (
        <div style={{borderRadius: '8px', overflow: 'hidden', border: '1px solid #E2E8F0'}}>
            <div style={{height: '150px', width: '100%'}}>
                <GoogleMapReact
                    bootstrapURLKeys={{key: process.env.REACT_APP_GOOGLE_MAPS_KEY || ''}}
                    center={{lat: position.lat, lng: position.lng}}
                    zoom={15}
                    options={{disableDefaultUI: true, gestureHandling: 'none'}}
                >
                    <PinMarker lat={position.lat} lng={position.lng}/>
                </GoogleMapReact>
            </div>
            <div style={{
                padding: '6px 10px', backgroundColor: 'white',
                fontSize: '11px', color: '#64748B', borderTop: '1px solid #E2E8F0',
            }}>
                {position.lat.toFixed(5)}, {position.lng.toFixed(5)}
                {position.last_message && (
                    <span style={{marginLeft: '8px', color: '#94A3B8'}}>
                        · {new Date(position.last_message).toLocaleTimeString()}
                    </span>
                )}
            </div>
        </div>
    );
}
